<template>
  <div class="admin_cartitems">
    <v-card>
      <v-toolbar flat color="white">
        <v-card-title>
          <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title @click="checkItems" v-if="user">
          {{user.name}}'s {{ $t('navigation_cart') }} 
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title>
          ({{cartitems.length}}) {{ $t('gen_item') }} 
        </v-card-title>
      </v-toolbar>
      <v-data-table :headers="headers" :items="cartitems"  :search="search" sort-by="name" class="elevation-1"><!--  -->
        <template v-slot:item.name="{ item }">
          <b>{{ item.product_name }}</b>
        </template>
        <template v-slot:item.price="{ item }">
          <b>{{ item.product_price | currency('K ') }}</b>
        </template>
        <template v-slot:item.total="{ item }">
          <b>{{ item.product_total | currency('K ')}}</b>
        </template>
        <template v-slot:item.image="{ item }">
          <v-img height="70px" width="70px" :src="getImage(item.product_image)"></v-img>
        </template>
        <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon medium color="orange darken-2" @click="deleteClient(item)">mdi-delete</v-icon>
                </span>
              </template>
              <span>{{ $t('remove') }}</span>
            </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-list-item-title><b>Cart Is Empty</b></v-list-item-title>
        </template>
      </v-data-table>
      <v-toolbar flat color="white">
        <v-card-title>
          <table>
            <tr>
              <th>{{ $t('orders_qty') }}: </th>
              <td>{{quantitySum()}} <b>{{ $t('orders_items') }}</b></td>
            </tr>
          </table>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title>
          <table>
            <tr>
              <th>{{ $t('cart_total') }}: </th>
              <td><b> {{priceSum() | currency('K')}}</b></td>
            </tr>
          </table>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title>
          <router-link to="/checkout"><v-btn color="indigo darken-1" dark rounded>{{ $t('checkout') }}</v-btn></router-link> 
        </v-card-title>
      </v-toolbar>
    </v-card>
  </div>
</template>

<script>
  import {fb,db} from '@/firebase';

  export default {
    name : "admin_cartitems",
    data: () => ({
      search: '',
      nav_title: 'Cart Page',
      headers: [
        { text: 'Product Image', align: 'center', value: 'image' },
        { text: 'Product Name', align: 'center', value: 'name'},
        { text: 'Product Client', align: 'center', value: 'client_name'},
        { text: 'Region', align: 'center', value: 'client_town'},
        { text: 'Product Price', align: 'center', value: 'price'},
        { text: 'Product Quality', align: 'center', value: 'product_quantity'},
        { text: 'Product Total', align: 'center', value: 'total'},
        { text: 'Actions', value: 'action', sortable: false },
      ],
      cartitems: [],
      user: null,
      matchitems:[]
    }),

    created(){
      //fetch data from the firestore
      db.collection('cartitems').where('user','==',fb.auth().currentUser.uid).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let cartitem = doc.data()
          cartitem.id =  doc.id
          this.cartitems.push(cartitem) 
        })
      })
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data()
          this.user.id = doc.id//
        })
      })
    },
    
    firestore: {
      carti: db.collection('cartitems')
    },

    methods: {
      priceSum(){
          return this.cartitems.reduce((prev,cur) => prev + cur.product_total,0)
      },
      quantitySum(){
          return this.cartitems.reduce((prev,cur) => prev + cur.product_quantity,0)
      },
      checkItems(){
        for(var i=0; i<=this.cartitems.length; i++){
          if(this.cartitem.user == this.user.alias){
            this.matchitems.push(this.cartitem)
          }
        }
      },
      getImage(product_image){
        return product_image[0]
      },

      back(){
        this.$router.go(-1)
      },
      
      deleteClient(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })/* eslint-enable */
        .then((result) => {
          if (result.value) {
            this.$firestoreRefs.carti.doc(item.id).delete()
            .then(() => {
              /* eslint-disable */
              Toast.fire({
                type: 'success',
                title: 'Deleted successfully'
              })
              /* eslint-enable */
              this.cartitems = this.cartitems.filter(cartitem =>{
                return cartitem.id != item.id
              })
            })            
          }
        })
      }
    }
  }
</script>
